module.exports = __webpack_public_path__ + "img/74.5e4f5c7d.jpg";